import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { formatDate, formatToUSD, getDaysInMonth } from '../network/helper';
import { getDateFormatted,getTodayDateUSFormat } from '../control/Constant';

function ExcelExtracter( props ) {
    const { selectedMonth, selectedYear, monthlydata, yearlydata, bottomBlockdata, revenueData, attorneyMonthlyReport , showAttorneyReport, showDataExcel, subtenantIdExcel, monthlyEditdata  } = props;
    // console.log("dasd", props)

    // Function to create and download the Excel file
    const createAndDownloadExcel = async () => {
        // Create a new workbook and add a worksheet
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Daily Deposit');

        // Define base styles to be reused
        const allBorders = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        };
        const allBorders2 = {
            // top: { style: 'thick' },
            left: { style: 'medium' },
            // bottom: { style: 'thick' },
            right: { style: 'medium' }
        };
        const allBorders3 = {
            top: { style: 'medium' },
            left: { style: 'medium' },
            bottom: { style: 'medium' },
            right: { style: 'medium' }
        };

        // monthList
        const monthDateCount = 31;
        const ActualMonthDateCount = getDaysInMonth(selectedMonth, selectedYear);
        const monthsList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        // Set column widths to match the visual layout
        worksheet.columns = [
            { width: 1 },  // Column A
            { width: 5 }, // Column B
            { width: 15 }, // Column C
            { width: 15 }, // Column D
            { width: 24 }, // Column E
            { width: 1 }, // Column F
            { width: 5 }, // Column G
            { width: 15 }, // Column H
            { width: 15 }, // Column I
            { width: 15 }, // Column J
            { width: 1 }, // Column K
            { width: 5 }, // Column L
            { width: 15 }, // Column M
            { width: 15 }, // Column N
            { width: 15 }, // Column O
            { width: 1 }, // Column P
            { width: 5 }, // Column Q
            { width: 15 }, // Column R
            { width: 15 }, // Column S
            { width: 15 }, // Column T
            { width: 1 }, // Column U
            { width: 5 }, // Column V
            { width: 15 }, // Column W
            { width: 15 }, // Column X
            { width: 15 }, // Column y
            { width: 1 }, // Column z
        ];

        // Header - Row 1
        worksheet.getCell('B1').value = 'DEPOSIT REPORT';
        worksheet.getCell('B1').font = { bold: true, size: 24 };
        worksheet.mergeCells('B1:H1'); // merging from B1 to C1
        
        worksheet.getCell('B1').value = 'DEPOSIT REPORT';

        worksheet.getCell('M1').value = 'CURRENT AS OF: ' + formatDate();
        worksheet.getCell('M1').font = { bold: true, size: 18 };
        worksheet.getCell('M1').alignment = { horizontal: 'left' };
        worksheet.mergeCells('M1:Q1');

        // Function to apply styles to a column section
        { // ============================================================= TOP 5 TABLES ==========================================================
            const longBorder = (col, row) =>  {
                for(let i = row; i < (5 + monthDateCount + row); i++) worksheet.getCell(`${String.fromCharCode(65 + col - 1)}${i}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '000000' } }
            }
            const applyStyles = (startCol, headerTitle, shortTitle, headerColor, curMonthlyData, curYearlydata, curmonthlyEditdata) => {
                // Left Long Border
                longBorder(startCol - 1, 3);

                // Top Header (e.g., LIFE POINT LAW)
                const headerCell = worksheet.getCell(`${String.fromCharCode(65 + startCol - 1)}3`);
                headerCell.value = headerTitle;
                headerCell.style = {
                    font: { bold: true, size: 14, color: { argb: headerColor } },
                    alignment: { horizontal: 'center', vertical: 'middle' },
                    fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '00000000' } },
                    border: allBorders
                };
                worksheet.mergeCells(`${String.fromCharCode(65 + startCol - 1)}3:${String.fromCharCode(65 + startCol + 2)}3`);

                // Sub-headers (DEC MTD, YTD 2023)
                // Month filling
                const monthCell = worksheet.getCell(`${String.fromCharCode(65 + startCol - 1)}4`);
                monthCell.value = `${monthsList[Number(selectedMonth) - 1]?.toUpperCase()} MTD`;
                monthCell.style = {
                    font: { bold: true,  color: { argb: 'FFFFFFFF' } },
                    alignment: { horizontal: 'center' },
                    fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '00000000' } },
                    border: allBorders
                };
                worksheet.mergeCells(`${String.fromCharCode(65 + startCol - 1)}4:${String.fromCharCode(65 + startCol)}4`);

                for(let date = 1; date <= monthDateCount; date++) {
                    const rowNum = 4 + date;

                    const dateCell = worksheet.getCell(`${String.fromCharCode(65 + startCol - 1)}${rowNum}`);
                    dateCell.value = date <= ActualMonthDateCount ? date : '';
                    // dateCell.border = allBorders;
                    dateCell.style = {
                        font: { bold: true },
                        alignment: { horizontal: 'left' },
                    };

                    const dateValueCell = worksheet.getCell(`${String.fromCharCode(65 + startCol)}${rowNum}`);
                    dateValueCell.value = date <= ActualMonthDateCount ? (formatToUSD(curMonthlyData?.days[date - 1]?.total) || '-') : '';
                    // dateValueCell.border = allBorders;
                    dateValueCell.font = { bold: true };
                    dateValueCell.alignment = { horizontal: 'distributed' };
                }
                
                { // First Year 
                    const firstYearData = curYearlydata?.find(ele => ele.year == (selectedYear - 1));
                    const firstYearCell = worksheet.getCell(`${String.fromCharCode(65 + startCol + 1)}4`);
                    firstYearCell.value = `YTD ${selectedYear - 1}`;
                    firstYearCell.style = {
                        font: { bold: true,  color: { argb: 'FFFFFFFF' } },
                        alignment: { horizontal: 'center' },
                        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '00000000' } },
                        border: allBorders
                    };
                    worksheet.mergeCells(`${String.fromCharCode(65 + startCol + 1)}4:${String.fromCharCode(65 + startCol + 2)}4`);
                    
                    // Fill in First year (2023) data
                    for (let i = 0; i < monthsList.length; i++) {
                        const rowNum = 5 + i; // rows goes - 5 , 6 , 7 , ...
                        const monthNameCell = worksheet.getCell(`${String.fromCharCode(65 + startCol + 1)}${rowNum}`);
                        monthNameCell.value = monthsList[i];
                        monthNameCell.style = {
                            font: { bold: true },
                            fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'a6a6a6' } },
                            border: allBorders2
                        };
                        
                        const monthCell = worksheet.getCell(`${String.fromCharCode(65 + startCol + 2)}${rowNum}`);
                        monthCell.value = formatToUSD(firstYearData?.months?.[i]?.total) || '';
                        // monthCell.border = allBorders;
                        monthCell.font = { bold: true };
                        monthCell.alignment = { horizontal: 'distributed' };
                    }
                    const firstYearTotalLabelCell = worksheet.getCell(`${String.fromCharCode(65 + startCol + 1)}17`);
                    firstYearTotalLabelCell.value = `Total YTD ${selectedYear - 1}`
                    firstYearTotalLabelCell.style = {
                        border: allBorders3,
                        alignment: { wrapText: true, vertical: 'middle'},
                        font: { bold: true },
                        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'a6a6a6' } },
                    }
                    worksheet.mergeCells(`${String.fromCharCode(65 + startCol + 1)}17:${String.fromCharCode(65 + startCol + 1)}18`);
                    const firstYearTotalValueCell = worksheet.getCell(`${String.fromCharCode(65 + startCol + 2)}17`);
                    firstYearTotalValueCell.value = formatToUSD(firstYearData?.yearTotal) || "$     -"
                    firstYearTotalValueCell.style = {
                        border: allBorders3,
                        alignment: { wrapText: true },
                        font: { bold: true },
                        alignment: { horizontal: 'distributed', vertical: 'middle' },
                        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'a6a6a6' } },
                    }
                    worksheet.mergeCells(`${String.fromCharCode(65 + startCol + 2)}17:${String.fromCharCode(65 + startCol + 2)}18`);
                }

                { // Second Year 
                    const secondYearData = curYearlydata?.find(ele => ele.year == selectedYear);
                    const secondYearCell = worksheet.getCell(`${String.fromCharCode(65 + startCol + 1)}19`);
                    secondYearCell.value = selectedYear;
                    secondYearCell.style = {
                        font: { bold: true,  color: { argb: 'FFFFFFFF' } },
                        alignment: { horizontal: 'left' },
                        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '00000000' } },
                        border: allBorders2
                    };
                    worksheet.mergeCells(`${String.fromCharCode(65 + startCol + 1)}19:${String.fromCharCode(65 + startCol + 2)}19`);
                    
                    // Fill in second year (2024) data
                    for (let i = 0; i < monthsList.length; i++) {
                        const rowNum = 20 + i; // rows goes - 5 , 6 , 7 , ...
                        const monthNameCell = worksheet.getCell(`${String.fromCharCode(65 + startCol + 1)}${rowNum}`);
                        monthNameCell.value = monthsList[i];
                        monthNameCell.style = {
                            font: { bold: true },
                            border: allBorders2
                        };
                        
                        const monthCell = worksheet.getCell(`${String.fromCharCode(65 + startCol + 2)}${rowNum}`);
                        monthCell.value = formatToUSD(secondYearData?.months?.[i]?.total) || '';
                        // monthCell.border = allBorders;
                        monthCell.font = { bold: true };
                        monthCell.alignment = { horizontal: 'distributed' };
                    }
                    const secondYearTotalLabelCell = worksheet.getCell(`${String.fromCharCode(65 + startCol + 1)}32`);
                    secondYearTotalLabelCell.value = `Total YTD ${selectedYear}`
                    secondYearTotalLabelCell.style = {
                        border: allBorders3,
                        alignment: { wrapText: true },
                        font: { bold: true, color: { argb: 'FFFFFFFF' } },
                        alignment: { vertical: 'middle' },
                        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '000000' } },
                    }
                    worksheet.mergeCells(`${String.fromCharCode(65 + startCol + 1)}32:${String.fromCharCode(65 + startCol + 1)}35`);
                    const secondYearTotalValueCell = worksheet.getCell(`${String.fromCharCode(65 + startCol + 2)}32`);
                    secondYearTotalValueCell.value = formatToUSD(secondYearData?.yearTotal) || "$     -"
                    secondYearTotalValueCell.style = {
                        border: allBorders3,
                        alignment: { wrapText: true },
                        font: { bold: true, color: { argb: 'FFFFFFFF' } },
                        alignment: { horizontal: 'distributed', vertical: 'middle' },
                        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '000000' } },
                    }
                    worksheet.mergeCells(`${String.fromCharCode(65 + startCol + 2)}32:${String.fromCharCode(65 + startCol + 2)}35`);
                }

                // Footer rows
                const monthTotalAmount = '34,900';
                const footer1Rows = [
                    { label: 'MTD RUNNING TOTAL', color: '00B0F0' },
                    { label: formatToUSD(curMonthlyData?.total) || '-', color: 'BFBFBF' },
                ];
                footer1Rows.forEach((row, index) => {
                    const rowNum = monthDateCount + 5 + index;
                    const labelCell = worksheet.getCell(`${String.fromCharCode(65 + startCol - 1)}${rowNum}`);
                    labelCell.value = row.label;
                    labelCell.style = {
                        font: { bold: true },
                        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: row.color } },
                        border: allBorders,
                        alignment: { wrapText: true },
                    };
                    worksheet.mergeCells(`${String.fromCharCode(65 + startCol - 1)}${rowNum}:${String.fromCharCode(65 + startCol)}${rowNum}`);
                });

                const footer2Rows = [
                    { label: `${shortTitle == "Total" ? 'Total ' : ''}QB BALANCE`, color: '8ED973' },
                    { label: shortTitle == "Total" ? "TOTAL AVAIL. CREDIT" : shortTitle == '' ? '' : `${shortTitle} LOC AVAIL`, color: 'FFFF99' }
                ];
                footer2Rows.forEach((row, index) => {
                    const rowNum = monthDateCount + 5 + index;
                    const labelCell = worksheet.getCell(`${String.fromCharCode(65 + startCol + 1)}${rowNum}`);
                    labelCell.value = row.label;
                    labelCell.style = {
                        font: { bold: true },
                        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: row.color } },
                        border: allBorders,
                        alignment: { wrapText: true },
                    };
                    // console.log(curmonthlyEditdata,"curmonthlyEditdata",row?.label, `${shortTitle} LOC AVAIL`)
                    const valueCell = worksheet.getCell(`${String.fromCharCode(65 + startCol + 2)}${rowNum}`);
                    valueCell.value = (row?.label == 'QB BALANCE' || row?.label == 'Total QB BALANCE') ? curmonthlyEditdata?.qbBalance : (row?.label == `${shortTitle} LOC AVAIL` || row?.label == 'TOTAL AVAIL. CREDIT') ? curmonthlyEditdata?.aolocAvail : '-';
                    valueCell.style = {
                        font: { bold: true },
                        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: row.color } },
                        border: allBorders,
                        alignment: { wrapText: true },
                    };
                });

                // Bottom Header (e.g., LIFE POINT LAW)
                const bottomHeaderCell = worksheet.getCell(`${String.fromCharCode(65 + startCol - 1)}38`);
                bottomHeaderCell.value = headerTitle;
                bottomHeaderCell.style = {
                    font: { bold: true, size: 14, color: { argb: headerColor } },
                    alignment: { horizontal: 'center', vertical: 'middle' },
                    fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '00000000' } },
                    border: allBorders
                };
                worksheet.mergeCells(`${String.fromCharCode(65 + startCol - 1)}38:${String.fromCharCode(65 + startCol + 2)}38`);
            };

            // Apply styles to each of the four main columns
            (['LPL','ALL']?.includes(showDataExcel)) && applyStyles(2, 'LIFE POINT LAW', 'LPL', 'FFCC0000', monthlydata['LPL'], yearlydata['LPL'],monthlyEditdata['LPL']);
            (['AO','ALL']?.includes(showDataExcel)) && applyStyles(7, 'AGING OPTIONS, INC', 'AO', '00B050', monthlydata['AO'], yearlydata['AO'],monthlyEditdata['AO']);
            // applyStyles(12, 'NAGACH HOLDINGS, LLC', '', 'E97132', monthlydata['NH'], yearlydata['NH']);
            (['FWPP','ALL']?.includes(showDataExcel)) && applyStyles(12, 'FEDERAL WAY PROF. PLAZA', '', '00B0F0', monthlydata['FWPP'], yearlydata['FWPP'],monthlyEditdata['FWPP']);
            (['ALL']?.includes(showDataExcel)) && applyStyles(17, 'ALL COMPANIES COMBINED', 'Total', 'FFFFFF', monthlydata['TOTAL'], yearlydata['TOTAL'],monthlyEditdata['TOTAL']);
            longBorder(21, 3)
        }

        { // ============================================================ BOTTOM 3 BLOCKS ==========================================================
            const applyBottomBlock = (startRow, headerTitle, dataObj) => {
                console.log(startRow, headerTitle,"startRowheaderTitle",dataObj)
                const greyFill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'BFBFBF' }
                };
                
                const blackFill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: '000000' }
                };

                // Color the first Rectable block: A41 to Z41 to Z50 to A41
                for (let i = 1; i <= 26; i++) { // 1 for A to 26 for Z
                    for(let j = startRow; j < startRow + 10; j++) {
                        const columnLetter = String.fromCharCode(64 + i);
                        const cell = worksheet.getCell(`${columnLetter}${j}`);
                        cell.fill = greyFill;

                        if(columnLetter == 'A' || columnLetter == 'Z' || j == startRow || j == (startRow + 9)) cell.fill = blackFill;
                    }
                }

                // Setting title 
                worksheet.mergeCells(`B${startRow + 1}:E${startRow + 2}`);
                const titleBlock = worksheet.getCell(`B${startRow + 1}`);
                titleBlock.value = headerTitle + ` ${getTodayDateUSFormat()}`;
                titleBlock.style = {
                    font: { bold: true, size: 28 },
                    fill: greyFill,
                    alignment: { horizontal: 'center' },
                };

                // 3 Need by ${date}
                const needStyle = {
                    font: { bold: true, size: 10 },
                    fill: greyFill,
                    alignment: { horizontal: 'center' },
                }
                for(let i = 3; i <= 5; i++) {
                    worksheet.mergeCells(`B${startRow + i}:C${startRow + i}`);
                    const needCell = worksheet.getCell(`B${startRow + i}`);
                    needCell.value = `NEED BY ${i==3 ? formatDate(dataObj?.needDate1) : i== 4 ? formatDate(dataObj?.needDate2) : formatDate(dataObj?.needDate3)}`
                    needCell.style = needStyle
                }

                // First 2 Colorful Columns
                { 
                    const rowsData = [
                        {
                            label: `PAY ROLL`,
                            value: formatToUSD(dataObj?.payrollValue),
                            color: 'FFCCFF'
                        },
                        {
                            label: 'CHECK RUN',
                            value: formatToUSD(dataObj?.checkrunValue),
                            color: 'FF5050'
                        },
                        {
                            label: `PAY ROLL`,
                            value: formatToUSD(dataObj?.payroll2Value),
                            color: '156082'
                        },
                        {
                            label: 'ROLLOVER AMOUNT',
                            value:  formatToUSD(dataObj?.rolloverValue),
                            color: 'FFCC66'
                        },
                        {
                            label: '',
                            value: formatToUSD(dataObj?.total),
                            color: '8ED973'
                        },
                    ]
                    for(let i = 0; i < 5; i++) {
                        const labelCell = worksheet.getCell(`D${startRow + 3 + i}`);
                        const valueCell = worksheet.getCell(`L${startRow + 3 + i}`);
                        labelCell.value = rowsData[i].label;
                        valueCell.value = rowsData[i].value;
                        labelCell.style = {
                            font: { bold: true, size: 20 },
                            fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: rowsData[i].color } },
                            border: allBorders,
                        }
                        valueCell.style = {
                            font: { bold: true, size: 20 },
                            fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: rowsData[i].color } },
                            border: allBorders,
                            alignment: { horizontal: 'distributed' },
                        }
                        worksheet.mergeCells(`D${startRow + 3 + i}:K${startRow + 3 + i}`);
                        worksheet.mergeCells(`L${startRow + 3 + i}:P${startRow + 3 + i}`);
                    }
                }

                // Second 3 BIG Columns
                {
                    const columnData = [
                        {
                            label: 'TOTAL NEEDED',
                            value: formatToUSD(dataObj?.totalNeeded),
                            valueColor: 'A6A6A6',
                            startCol: 'Q',
                            endCol: 'R',
                        },
                        {
                            label: "REC'D SO FAR",
                            value: formatToUSD(dataObj?.redsofar),
                            valueColor: 'FFFF99',
                            startCol: 'S',
                            endCol: 'T',
                        },
                        {
                            label: 'TO BRING IN',
                            value: formatToUSD(dataObj?.toBringIn),
                            valueColor: '000000',
                            startCol: 'U',
                            endCol: 'X',
                        },
                    ]
                    for(let i = 0; i < 3; i++) {
                        const colData = columnData[i];
                        const labelCell = worksheet.getCell(`${colData.startCol}${startRow + 2}`);
                        const valueCell = worksheet.getCell(`${colData.startCol}${startRow + 3}`);
                        labelCell.value = colData.label;
                        valueCell.value = colData.value;
                        labelCell.style = {
                            font: { bold: true, size: 14 },
                            border: allBorders,
                            alignment: { horizontal: 'center' },
                        }
                        valueCell.style = {
                            font: { bold: true, size: 20, color: { argb: colData.valueColor == '000000' ? 'FFFFFF' : '000000' } },
                            alignment: { horizontal: 'distributed', vertical: 'middle' },
                            border: allBorders,
                            fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: colData.valueColor } }
                        }
                        worksheet.mergeCells(`${colData.startCol}${startRow + 2}:${colData.endCol}${startRow + 2}`);
                        worksheet.mergeCells(`${colData.startCol}${startRow + 3}:${colData.endCol}${startRow + 7}`);
                    }
                }


            }
                // if (subtenantIdExcel === 'All_Companies') {
                // applyBottomBlock(41, "All Entities", bottomBlockdata?.['TOTAL']);
                // }

                // if (subtenantIdExcel === 'All_Companies' || subtenantIdExcel === 'life_point_law') {
                // applyBottomBlock(53, "LPL", bottomBlockdata?.['LPL']);
                // }

                // if (subtenantIdExcel === 'All_Companies' || subtenantIdExcel === 'aging_options') {
                // applyBottomBlock(64, "AO", bottomBlockdata?.['AO']);
                // }

                // if (subtenantIdExcel === 'All_Companies' || subtenantIdExcel === 'federal_way_plaza') {
                // applyBottomBlock(75, "FWPP", bottomBlockdata?.['FW']);
                // }

        }

        if(showAttorneyReport) { // ============================================================ WORKSHEET 2 ==========================================================
            const worksheet2 = workbook.addWorksheet('Attorney Report');
            worksheet2.columns = [
                { width: 1 },  // Column A
                { width: 50 }, // Column B
                { width: 30 }, // Column C
                { width: 30 }, // Column D
                { width: 30 }, // Column E
                { width: 30 }, // Column F
                { width: 30 }, // Column G
                { width: 30 }, // Column H
                { width: 30 }, // Column I
                { width: 30 }, // Column J
                { width: 30 }, // Column K
                { width: 30 }, // Column L
                { width: 30 }, // Column M
                { width: 30 }, // Column N
                { width: 30 }, // Column O
                { width: 30 }, // Column P
                { width: 30 }, // Column Q
                { width: 30 }, // Column R
                { width: 30 }, // Column S
                { width: 30 }, // Column T
                { width: 30 }, // Column U
                { width: 30 }, // Column V
                { width: 30 }, // Column W
                { width: 30 }, // Column X
                { width: 30 }, // Column y
                { width: 30 }, // Column z
            ];
            const colColors = ["FF9F9F", "FFC000", "8AE777", "FF99FF", "00B0F0", "00FFFF", "FFFFFF"]

            // Giving borders
            for(let i = 1; i <= (14 + attorneyMonthlyReport?.length); i++) worksheet2.getCell(`A${i}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '000000'} } // A1 -> A20
            for(let i = 0; i < 10; i++) worksheet2.getCell(`${String.fromCharCode(65 + i)}1`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '000000'} } // A1 -> J1
            for(let i = 0; i < 11; i++) worksheet2.getCell(`${String.fromCharCode(65 + i)}10`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '000000'} } // A10 -> K10
            for(let i = 0; i < 11; i++) worksheet2.getCell(`${String.fromCharCode(65 + i)}${attorneyMonthlyReport?.length + 14}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '000000'} } // A20 -> K20
            for(let i = 1; i <= 10; i++) worksheet2.getCell(`${String.fromCharCode(65 + attorneyMonthlyReport?.length + 3)}${i}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '000000'} } // J1 -> J10
            for(let i = 10; i <= (14 + attorneyMonthlyReport?.length); i++) worksheet2.getCell(`K${i}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '000000'} } // K10 -> K20

            // First Table
            {
                const columnsData = [
                    [
                        `${monthsList[Number(selectedMonth) - 1]?.toUpperCase()}-${String(selectedYear)?.substr(2, 2)}`,
                        "MTD Initials Held",
                        "MTD Initials Retained",
                        "Closed percentage",
                        "MTD Revenue Retained",
                        "MTD Revenue Collected from initials",
                        "MTD Revenue collected not from initials",
                        "TOTAL COLLECTED"
                    ],
                    ...attorneyMonthlyReport,
                    attorneyMonthlyReport?.reduce((tempFinal, curValue) => {
                        for(let i = 1; i <= 7; i++) {
                            tempFinal[i] += (curValue?.[i] || 0);
                        }
                        return tempFinal;
                    }, ["TOTAL", 0, 0, 0, 0, 0, 0, 0]),
                ]

                for(let i = 0; i < columnsData.length; i++) {
                    const colChar = String.fromCharCode(65 + i + 1);
                    const colData = columnsData[i];
                    for(let j = 0; j < columnsData[0].length; j++) {
                        const celBlock = worksheet2.getCell(`${colChar}${j + 2}`);
                        celBlock.value = (i == 0 || j == 0) ? colData?.[j] : (formatToUSD(colData?.[j]) || '-');
                        celBlock.style = {
                            alignment: { wrapText: true, horizontal: j == 0 ? 'center' : i == 0 ? 'left' : 'distributed', vertical: 'middle' },
                            font: { bold: true, size: 12, color: { argb: colData[j] == "TOTAL COLLECTED" ? '137E43' : '000000' }},
                            border: allBorders,
                            fill: i == 0 ? undefined : { type: 'pattern', pattern: 'solid', fgColor: { argb: colColors[i - 1] } },
                        }
                    }
                }
            }

            // Second Table
            {
                // Setting 1st Headers
                const header1 = ["Revenues Collected", "Day", "Week", "Month", "YTD"]
                for(let i = 0; i < header1.length; i++) {
                    let cellBlock;
                    if(i == 0) {
                        cellBlock = worksheet2.getCell('B11');
                    } else {
                        cellBlock = worksheet2.getCell(`${String.fromCharCode(65 + (i * 2))}11`);
                        worksheet2.mergeCells(`${String.fromCharCode(65 + (i * 2))}11:${String.fromCharCode(65 + (i * 2) + 1)}11`);
                    }
                    cellBlock.value = header1[i];
                    cellBlock.style = {
                        alignment: { horizontal: 'center' },
                        font: { bold: true, size: 12 },
                        border: allBorders,
                    }

                }

                // Setting 2nd Headers
                const header2 = [formatDate(), "Daily Goal", "Yesterday Actual", "Weekly Goal", "WTD Actual", "Monthly Goal", "MTD Actual", "Yearly Goal", "YTD Actual"];
                for(let i = 0; i < header2.length; i++) {
                    let cellBlock = worksheet2.getCell(`${String.fromCharCode(65 + i + 1)}12`);
                    cellBlock.value = header2[i];
                    cellBlock.style = {
                        alignment: { horizontal: 'center' },
                        font: { bold: i == 0 ? true : false, size: 12 },
                        border: allBorders,
                    }
                }

                // Filling Data
                const rowsData = [
                    ...revenueData,
                    revenueData?.reduce((tempFinal, curValue) => {
                        for(let i = 1; i <= 8; i++) {
                            tempFinal[i] += (curValue?.[i] || 0);
                        }
                        return tempFinal;
                    }, ["TOTAL", 0, 0, 0, 0, 0, 0, 0, 0])
                ]
                for(let i = 0; i < rowsData.length; i++) {
                    const rowData = rowsData[i];
                    for(let j = 0; j < header2.length; j++) {
                        const cellBlock = worksheet2.getCell(`${String.fromCharCode(65 + j + 1)}${i + 13}`)
                        cellBlock.value = (j == 0 ) ? rowData[j] : formatToUSD(rowData[j]);
                        cellBlock.style = {
                            alignment: { horizontal: j == 0 ? 'left' : 'distributed' },
                            font: { bold: true, size: 12, color: { argb: rowData[j] == "Total" ? '137E43' : '000000' }},
                            border: allBorders,
                            fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: colColors[i] } }
                        }
                    }
                }
            }

        }

        // Write to buffer and save
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), `DASHBOARD ${showDataExcel == 'ALL' ? 'MASTER' : showDataExcel} ${selectedYear}.xlsx`);
    };

    return (
        <button className="w-1/8 bg-green-400 text-black font-semibold py-2 px-4 rounded" onClick={createAndDownloadExcel}>Download</button>
    );
}

export default ExcelExtracter;